/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        alert: {
            borderRadius: {
                value: "4px",
                type: "dimension",
            },
            borderWidth: {
                value: "1px",
                type: "dimension",
            },
            paddingLeft: {
                value: "16px",
                type: "dimension",
            },
            paddingRight: {
                value: "8px",
                type: "dimension",
            },
            paddingVertical: {
                value: "4px",
                type: "dimension",
            },
            gap: {
                value: "8px",
                type: "dimension",
            },
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            icon: {
                width: {
                    value: "16px",
                    type: "dimension",
                },
                height: {
                    value: "16px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "12px",
                    type: "dimension",
                },
                paddingRight: {
                    value: "8px",
                    type: "dimension",
                },
            },
            message: {
                paddingVertical: {
                    value: "10px",
                    type: "dimension",
                },
                gap: {
                    value: "4px",
                    type: "dimension",
                },
                title: {
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "fontWeight",
                    },
                    paddingBottom: {
                        value: "4px",
                        type: "dimension",
                    },
                },
                text: {
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.25rem",
                        type: "dimension",
                    },
                    color: {
                        value: "#1e1e1e",
                        type: "color",
                    },
                },
            },
            success: {
                borderColor: {
                    value: "#05704B",
                    type: "color",
                },
                icon: {
                    color: {
                        value: "#05704B",
                        type: "color",
                    },
                },
                message: {
                    title: {
                        color: {
                            value: "#05704B",
                            type: "color",
                        },
                    },
                },
            },
            info: {
                borderColor: {
                    value: "#455D82",
                    type: "color",
                },
                icon: {
                    color: {
                        value: "#455D82",
                        type: "color",
                    },
                },
                message: {
                    title: {
                        color: {
                            value: "#455D82",
                            type: "color",
                        },
                    },
                },
            },
            warning: {
                borderColor: {
                    value: "#EAA14B",
                    type: "color",
                },
                icon: {
                    color: {
                        value: "#EAA14B",
                        type: "color",
                    },
                },
                message: {
                    title: {
                        color: {
                            value: "#935206",
                            type: "color",
                        },
                    },
                },
            },
            error: {
                borderColor: {
                    value: "#AF292E",
                    type: "color",
                },
                icon: {
                    color: {
                        value: "#AF292E",
                        type: "color",
                    },
                },
                message: {
                    title: {
                        color: {
                            value: "#AF292E",
                            type: "color",
                        },
                    },
                },
            },
        },
    },
};
export default tokens;
